import type { SignUpRow } from "../../components/signUp/SignUpDataTable";

export const buildSignUpRows = (data: {
  rotations: any[];
  sessions: any[];
  enrollments: any[];
  preferences: any[];
}): SignUpRow[] => {
  return data.sessions.map((s) => {
    const rotation = data.rotations.find((r) => r._id === s.rotation);
    const enrollment = data.enrollments.find((e) => e.session === s._id);
    const preferences = data.preferences.find((p) => p.session === s._id);

    const isEditOpen = () => {
      if (!rotation.studentsCanEdit.from || !rotation.studentsCanEdit.to)
        return true;

      const from = new Date(rotation.studentsCanEdit.from);
      const to = new Date(rotation.studentsCanEdit.to);

      const now = new Date();
      return now.getTime() >= from.getTime() && now.getTime() <= to.getTime();
    };

    return {
      rotationId: rotation._id,
      rotationDate: rotation.date,
      editOpen: isEditOpen(),
      sessionId: s._id,
      sessionName: s.name,
      multiWeek: !s.singleton,
      enrollmentId: enrollment?._id,
      preferencesId: preferences?._id,
    };
  });
};
